import { Helmet } from "react-helmet-async";
import Button from "@components/Button";

const NotFound = () => {
	return (
		<div className="flex flex-col items-center justify-between max-h-screen space-y-6 ">
			<Helmet>
				<title>Page Not Found | Steer Smart Driving School</title>
				<meta name="description" content="The page you're looking for doesn't exist. Return to Steer Smart Driving School's homepage to find driving lessons and services in Canberra." />
				<meta name="robots" content="noindex, nofollow" />
			</Helmet>
			<p className="text-xl font-generalSans">
				Sorry, The Page You Are Looking For Is Not Found
			</p>
			<Button buttonName="Back to Home" buttonLink="/" buttonStyle="primary" />
		</div>
	);
};

export default NotFound;
